import React from "react";
import { translate } from "../Services/translation";

const Cookie = ({ languages, accept }) => {
    if (window.location.pathname != translate('cookie.readmoreLink')) {
        return (
            <>
                <div className="cookies-container">
                    <h2>{translate('cookie.title')}</h2>
                    <p>{translate('cookie.description')}</p>
                    <div>
                        <a onClick={() => accept()} className="main__button green" href="#" title="Startsida">{translate('cookie.accept')}</a>
                        <a className="main__button" href={translate('cookie.readmoreLink')} title="Startsida">{translate('cookie.readmore')}<i className="main__icon"></i></a>
                    </div>
                </div>
            </>
        )
    }
    return null;
};

export default Cookie;